// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1iWhy","label":"Section_label__Wxidl","contentWrap":"Section_contentWrap__3Do2j","footer":"Section_footer__1VfIU","footerInner":"Section_footerInner__3dDy7"};